import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const messages = document.getElementById("chat-conversation--content");
    this.resetScroll(messages);
  }

  disconnect() {
  }

  resetScroll(messages) {
    messages.scrollTop = messages.scrollHeight - messages.clientHeight;
  }
}

